import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-356fdcb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-10" }
const _hoisted_2 = {
  class: "m-4 text-3xl",
  "data-cy": "header-privacy"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-4" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Erklärung der Informationspflicht (Datenschutzerklärung)"),
  /*#__PURE__*/_createTextVNode(" Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Beim Besuch unserer Webseite wird Ihre IP-Adresse, Beginn und Ende der Sitzung für die Dauer dieser Sitzung erfasst. Dies ist technisch bedingt und stellt damit ein berechtigtes Interesse iSv Art 6 Abs 1 lit f DSGVO dar. "),
  /*#__PURE__*/_createElementVNode("h2", null, "Kontakt mit uns"),
  /*#__PURE__*/_createTextVNode(" Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs Monate bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. "),
  /*#__PURE__*/_createElementVNode("h2", null, "Cookies"),
  /*#__PURE__*/_createTextVNode(" Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen. Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein. "),
  /*#__PURE__*/_createElementVNode("h2", null, "Web-Analyse"),
  /*#__PURE__*/_createTextVNode(" Diese Website nutzt aufgrund unserer berechtigten Interessen zur Optimierung und Analyse unseres Online-Angebots im Sinne des Art. 6 Abs. 1 lit. f. DSGVO den Dienst „Google Analytics“, welcher von der Google Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) angeboten wird. Der Dienst (Google Analytics) verwendet „Cookies“ – Textdateien, welche auf Ihrem Endgerät gespeichert werden. Die durch die Cookies gesammelten Informationen werden im Regelfall an einen Google-Server in den USA gesandt und dort gespeichert."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Google LLC hält das europäische Datenschutzrecht ein und ist unter dem Privacy-Shield-Abkommen zertifiziert: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.privacyshield.gov/",
    target: "_blank",
    rel: "noopener"
  }, "https://www.privacyshield.gov/"),
  /*#__PURE__*/_createTextVNode(" Auf dieser Website greift die IP-Anonymisierung. Die IP-Adresse der Nutzer wird innerhalb der Mitgliedsstaaten der EU und des Europäischen Wirtschaftsraum und in den anderen Vertragsstaaten des Abkommens gekürzt. Nur in Einzelfällen wird die IP-Adresse zunächst ungekürzt in die USA an einen Server von Google übertragen und dort gekürzt. Durch diese Kürzung entfällt der Personenbezug Ihrer IP-Adresse. Die vom Browser übermittelte IP-Adresse des Nutzers wird nicht mit anderen von Google gespeicherten Daten kombiniert."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Im Rahmen der Vereinbarung zur Auftragsdatenvereinbarung, welche wir als Websitebetreiber mit der Google Inc. geschlossen haben, erstellt diese mithilfe der gesammelten Informationen eine Auswertung der Websitenutzung und der Websiteaktivität und erbringt mit der Internetnutzung verbundene Dienstleistungen. Die von Google in unserem Auftrag erhobenen Daten werden genutzt, um die Nutzung unseres Online-Angebots durch die einzelnen Nutzer auswerten zu können, z. B. um Reports über die Aktivität auf der Website zu erstellen, um unser Online-Angebot zu verbessern."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sie haben die Möglichkeit, die Speicherung der Cookies auf Ihrem Gerät zu verhindern, indem Sie in Ihrem Browser entsprechende Einstellungen vornehmen. Es ist nicht gewährleistet, dass Sie auf alle Funktionen dieser Website ohne Einschränkungen zugreifen können, wenn Ihr Browser keine Cookies zulässt. Weiterhin können Sie durch ein Browser-Plugin verhindern, dass die durch Cookies gesammelten Informationen (inklusive Ihrer IP-Adresse) an die Google Inc. gesendet und von der Google Inc. genutzt werden. Folgender Link führt Sie zu dem entsprechenden Plugin: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://tools.google.com/",
    target: "_blank",
    rel: "noopener"
  }, "https://tools.google.com/"),
  /*#__PURE__*/_createElementVNode("h2", null, "Nutzung von Social-Media-Plugins von Facebook/Instagram"),
  /*#__PURE__*/_createTextVNode(" Aufgrund unseres berechtigten Interesses an der Analyse, Optimierung und dem Betrieb unseres Online-Angebotes (im Sinne des Art. 6 Abs. 1 lit. f. DSGVO), verwendet diese Website das Facebook-Social-Plugin, welches von der Facebook Inc. (1 Hacker Way, Menlo Park, California 94025, USA) betrieben wird. Erkennbar sind die Einbindungen an dem Facebook-Logo bzw. an den Begriffen „Like“, „Gefällt mir“, „Teilen“ in den Farben Facebooks (Blau und Weiß)."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Informationen zu allen Facebook-Plugins finden Sie über den folgenden Link: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://developers.facebook.com/docs/plugins/",
    target: "_blank",
    rel: "noopener"
  }, "https://developers.facebook.com/docs/plugins/"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Facebook Inc. hält das europäische Datenschutzrecht ein und ist unter dem Privacy-Shield-Abkommen zertifiziert: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.privacyshield.gov/",
    target: "_blank",
    rel: "noopener"
  }, "https://www.privacyshield.gov/"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Das Plugin stellt eine direkte Verbindung zwischen Ihrem Browser und den Facebook-Servern her. Der Websitebetreiber hat keinerlei Einfluss auf die Natur und den Umfang der Daten, welche das Plugin an die Server der Facebook Inc. übermittelt. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Informationen dazu finden Sie hier: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/",
    target: "_blank",
    rel: "noopener"
  }, "https://www.facebook.com/"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Das Plugin informiert die Facebook Inc. darüber, dass Sie als Nutzer diese Website besucht haben. Es besteht hierbei die Möglichkeit, dass Ihre IP-Adresse gespeichert wird. Sind Sie während des Besuchs auf dieser Website in Ihrem Facebook-Konto eingeloggt, werden die genannten Informationen mit diesem verknüpft. Nutzen Sie die Funktionen des Plugins – etwa indem Sie einen Beitrag teilen oder „liken“ –, werden die entsprechenden Informationen ebenfalls an die Facebook Inc. übermittelt. Möchten Sie verhindern, dass die Facebook. Inc. diese Daten mit Ihrem Facebook-Konto verknüpft, loggen Sie sich bitte vor dem Besuch dieser Website bei Facebook aus und löschen Sie die gespeicherten Cookies. Über Ihr Facebook-Profil können Sie weitere Einstellungen zur Datenverarbeitung für Werbezwecke tätigen oder der Nutzung Ihrer Daten für Werbezwecke widersprechen."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Zu den Einstellungen gelangen Sie hier: Profileinstellungen bei Facebook: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/ads",
    target: "_blank",
    rel: "noopener"
  }, "https://www.facebook.com/ads"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Cookie-Deaktivierungsseite der US-amerikanischen Website: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://optout.aboutads.info",
    target: "_blank",
    rel: "noopener"
  }, "http://optout.aboutads.info"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Cookie-Deaktivierungsseite der europäischen Website: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://optout.networkadvertising.org ",
    target: "_blank",
    rel: "noopener"
  }, "http://optout.networkadvertising.org "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Welche Daten, zu welchem Zweck und in welchem Umfang Facebook Daten erhebt, nutzt und verarbeitet und welche Rechte sowie Einstellungsmöglichkeiten Sie zum Schutz Ihrer Privatsphäre haben, können Sie in den Datenschutzrichtlinien von Facebook nachlesen."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Diese finden Sie hier: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/about/",
    target: "_blank",
    rel: "noopener"
  }, "https://www.facebook.com/about/"),
  /*#__PURE__*/_createElementVNode("h2", null, "Datenschutzerklärung für unsere Social Media Seiten"),
  /*#__PURE__*/_createTextVNode(" Nachfolgend möchten wir Sie über den Umgang mit Ihren Daten gem. Art. 13 Datenschutzgrundverordnung (DSGVO) informieren. "),
  /*#__PURE__*/_createElementVNode("h2", null, "Verantwortlicher"),
  /*#__PURE__*/_createTextVNode(" Jürgen Hahn, MovingLayers GmbH betreibt folgende Social Media Seiten:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Twitter: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://twitter.com/MovingLayers",
        target: "_blank",
        rel: "noopener"
      }, "https://twitter.com/MovingLayers")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("LinkedIn: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.linkedin.com/company/movinglayers",
        target: "_blank",
        rel: "noopener"
      }, "https://www.linkedin.com/company/movinglayers")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Github: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/MovingLayers",
        target: "_blank",
        rel: "noopener"
      }, "https://github.com/MovingLayers")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Xing: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.xing.com/pages/movinglayers",
        target: "_blank",
        rel: "noopener"
      }, "https://www.xing.com/pages/movinglayers")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Neben uns gibt es noch den Betreiber der Social Media Plattform an sich. Auch dieser ist insofern ein weiterer Verantwortlicher, der eine Datenverarbeitung durchführt, auf die wir jedoch nur begrenzten Einfluss haben. An den Stellen, an denen wir Einfluss nehmen und die Datenverarbeitung parametrisieren können, wirken wir im Rahmen der uns zur Verfügung stehenden Möglichkeiten auf den datenschutzgerechten Umgang durch den Betreiber der Social Media Plattform hin. An vielen Stellen können wir die Datenverarbeitung durch den Betreiber der Social Media Plattform aber nicht beeinflussen und wissen auch nicht genau, welche Daten dieser verarbeitet. "),
  /*#__PURE__*/_createElementVNode("h2", null, "Datenverarbeitung durch uns"),
  /*#__PURE__*/_createTextVNode(" Die von Ihnen auf unseren Social Media Seiten eingegebenen Daten wie z. B. Kommentare, Videos, Bilder, Likes, öffentliche Nachrichten etc. werden durch die Social Media Plattform veröffentlicht und von uns zu keiner Zeit für andere Zwecke verwendet oder verarbeitet. Wir behalten uns lediglich vor, Inhalte zu löschen, sofern dies erforderlich sein sollte. Ggf. teilen wir Ihre Inhalte auf unserer Seite, wenn dies eine Funktion der Social Media Plattform ist und kommunizieren über die Social Media Plattform mit Ihnen. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Die Datenverarbeitung erfolgt im Interesse unserer Öffentlichkeitsarbeit und Kommunikation. Wenn Sie einer bestimmten Datenverarbeitung, auf die wir einen Einfluss haben, widersprechen möchten, wenden Sie sich bitte an Jürgen Hahn. Wir prüfen Ihren Widerspruch dann."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sofern Sie uns eine Anfrage auf der Social Media Plattform stellen, verweisen wir je nach der erforderlichen Antwort ggf. auch auf andere, sichere Kommunikationswege, die Vertraulichkeit garantieren. Sie haben immer die Möglichkeit, uns vertrauliche Anfragen an unsere Anschrift zu schicken. Wie bereits ausgeführt, achten wir an den Stellen, an denen uns der Anbieter der Social Media Plattform die Möglichkeit gibt, darauf, unsere Social Media Seiten möglichst datenschutzkonform zu gestalten."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Wir nutzen die Social Media Plattformen für Werbezwecke. Dabei greifen wir auch auf die demografischen, interessenbasierten, verhaltensbasierten oder standortbasierten Zielgruppendefinitionen für Werbung zurück, die uns der Betreiber der jeweiligen Social Media Plattform zur Verfügung stellt. Nähere Informationen zur Datenerfassung und Datenverarbeitung auf den Social Media Plattformen sowie dem dortigen Schutz Ihrer Privatsphäre finden Sie in den unten aufgeführten Datenschutzerklärungen der jeweiligen Anbieter. Im Hinblick auf Statistiken, die uns der Anbieter der Social Media Plattform zur Verfügung stellt, können wir diese nur bedingt beeinflussen und auch nicht abschalten. Wir achten aber darauf, dass uns keine zusätzlichen optionalen Statistiken zur Verfügung gestellt werden, die personenbezogene Daten verarbeiten. Für einzelne Social Media Kanäle nutzen wir Conversion-Tracking-Möglichkeiten. Dafür haben wir entsprechende Pixel bzw. Tags auf unserer Webseite eingebunden, um Conversion-Daten zu erfassen. "),
  /*#__PURE__*/_createElementVNode("h2", null, "Datenverarbeitung durch den Betreiber der Social Media Plattform"),
  /*#__PURE__*/_createTextVNode(" Der Betreiber der Social Media Plattform setzt Webtrackingmethoden ein. Das Webtracking kann dabei auch unabhängig davon erfolgen, ob Sie bei der Social Media Plattform angemeldet oder registriert sind. Wie bereits dargestellt können wir auf die Webtrackingmethoden der Social Media Plattform leider kaum Einfluss nehmen. Wir können dieses z.B. nicht abschalten. Bitte seien Sie sich darüber bewusst: Es kann nicht ausgeschlossen werden, dass der Anbieter der Social Media Plattform Ihre Profil- und Verhaltensdatendaten nutzt, etwa um Ihre Gewohnheiten, persönlichen Beziehungen, Vorlieben usw. auszuwerten. Wir haben insofern keinen Einfluss auf die Verarbeitung Ihrer Daten durch den Anbieter der Social Media Plattform. Nähere Informationen zur Datenverarbeitung durch den Anbieter der Social Media Plattform und weitere Widerspruchsmöglichkeiten finden Sie in der Datenschutzerklärung des Anbieters:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Twitter: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://twitter.com/de/privacy",
        target: "_blank",
        rel: "noopener"
      }, "https://twitter.com/de/privacy")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Facebook: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.facebook.com/privacy/explanation",
        target: "_blank",
        rel: "noopener"
      }, "https://www.facebook.com/privacy/explanation")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("YouTube: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://policies.google.com/privacy?hl=de",
        target: "_blank",
        rel: "noopener"
      }, "https://policies.google.com/privacy?hl=de")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Google+: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://policies.google.com/privacy?hl=de",
        target: "_blank",
        rel: "noopener"
      }, "https://policies.google.com/privacy?hl=de")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("LinkedIn: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.linkedin.com/legal/privacy-policy?trk=hb_ft_priv",
        target: "_blank",
        rel: "noopener"
      }, "https://www.linkedin.com/legal/privacy-policy?trk=hb_ft_priv")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("XING: "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://privacy.xing.com/de/datenschutzerklaerung",
        target: "_blank",
        rel: "noopener"
      }, "https://privacy.xing.com/de/datenschutzerklaerung")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, "Ihre Rechte"),
  /*#__PURE__*/_createTextVNode(" Ihnen stehen bezüglich Ihrer bei uns gespeicherten Daten grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei jha@movinglayers.eu oder der Datenschutzbehörde beschweren."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sie erreichen uns unter folgenden Kontaktdaten: "),
  /*#__PURE__*/_createElementVNode("h2", null, "MovingLayers GmbH"),
  /*#__PURE__*/_createTextVNode(" Gumpendorfer Straße 67/9"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1060 Wien | Austria"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Tel: +43 664 55 31 682"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" E-Mail: office@movinglayers.eu ")
], -1))

import { useI18n } from "vue-i18n";
import Toolbar from "@/components/Navigation/Toolbar";
import useUser from "@/composables/useUser";
import { useStore } from "@/composables/useTypedStore";
import {IonContent, IonPage, onIonViewWillEnter} from "@ionic/vue";
import { ref, computed } from "vue";
import UserDialogButton from "@/components/User/UserDialogButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'privacy',
  setup(__props) {

const { t } = useI18n({ useScope: "global" });
const user = useUser();
const isLoggedIn = ref(false);
const store = useStore();

const toolbarTitle = computed(() => {
      return isLoggedIn.value ? t('toolbar.privacy'):'';
    });

onIonViewWillEnter(() => {
  user.isLoggedIn().then((response) => {
    isLoggedIn.value = response;
    if(isLoggedIn.value){
      store.commit("app/showBottomNavigation");
    } 
  });   
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(Toolbar), { title: toolbarTitle.value }, _createSlots({ _: 2 }, [
        (isLoggedIn.value)
          ? {
              name: "trailing",
              fn: _withCtx(() => [
                _createVNode(UserDialogButton)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title"]),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('toolbar.privacy')), 1),
            _hoisted_3
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})